import { toast } from "@gigpro/ui/Toast";
import { ApiError } from "@sidegigllc/api";

export const toastApiErrorFor =
  (id?: string | number) =>
  (error: unknown): void => {
    toast.error(ApiError.fromThrown(error).getMainErrorMessage(), { id });
  };

export const toastApiError = toastApiErrorFor();
